export const SET_USER = 'set_user';
export const CLEAR_USER = 'clear_user';
export const SET_CURRENT_CHANNEL = 'set_current_channel';
export const SET_PRIVATE_CHANNEL = 'set_private_channel';
export const SET_USER_POSTS = 'set_user_posts';
export const SET_COLORS = 'set_colors';
export const OPEN_SIDEPANEL = 'open_sidepanel';